function FilteredAjaxForm(settings) {
    if (typeof settings === "undefined" || settings === null) {
        throw "No settings supplied.";
    }

    if (!(settings.targetElement instanceof Element)) {
        throw `Cannot initialize AjaxForm for ${settings.targetElement}, it's not an Element.`;
    }

    this.settings = {
        container: settings.targetElement,
        loader: settings.targetElement.querySelector(settings.loaderSelector || ".js-loader"),
        formSelector: settings.formSelector || "form",
        contentSelector: settings.contentSelector || ".js-ajax-form-content",
        boundSubmitHandler: this.submitForm.bind(this)
    };

    FilteredAjaxForm.checkSelector(this.settings.container, this.settings.formSelector);
    FilteredAjaxForm.checkSelector(this.settings.container, this.settings.contentSelector);

    this.bindForm();
}

FilteredAjaxForm.prototype.bindForm = function () {
    const container = this.settings.container;
    const form = container.querySelector(this.settings.formSelector);

    this.ajaxForm = {
        form: form,
        formElements: Array.from(form),
        content: container.querySelector(this.settings.contentSelector)
    };

    const hadFindFailure = this.ajaxForm.form.getAttribute("data-findfailure").toLowerCase() === "true";

    this.ajaxForm.formElements.forEach(function (element) {
        const elementName = element.nodeName.toLowerCase();

        if (elementName === "select") {
            element.disabled = hadFindFailure;
            element.addEventListener("change", this.settings.boundSubmitHandler);
            return;
        }

        if (elementName === "button") {
            element.addEventListener("click", this.settings.boundSubmitHandler);
            return;
        }

    }, this);
}

FilteredAjaxForm.prototype.unbindForm = function () {
    this.ajaxForm.formElements.forEach(function (element) {
        const elementName = element.nodeName.toLowerCase();

        if (elementName === "select") {
            element.removeEventListener("change", this.settings.boundSubmitHandler);
            return;
        }

        if (elementName === "button") {
            element.removeEventListener("click", this.settings.boundSubmitHandler);
            return;
        }

    }, this);
}

FilteredAjaxForm.prototype.submitForm = function (event) {
    const that = this;
    const trigger = event.currentTarget;

    const triggerName = trigger.nodeName.toLowerCase();
    
    if (triggerName === "button" && trigger.type === "submit") {
        event.preventDefault();
    }
    if (trigger.dataset.type === "viewMore") {
        this.viewMoreCompanies(event);
    }
    else {

        FilteredAjaxForm.toggleFormSelects(this.ajaxForm.formElements, false);

        const form = $(trigger.form);
        if (event.currentTarget.form.elements["pageNumber"] !== undefined) { trigger.form.elements["pageNumber"].value = 1; }
        let payload = form.serialize();
       
        if (payload.indexOf("managementFilter")!==-1) {
            payload += "&isManagement=true";
        }
        else {
            payload += "&isManagement=false";
        }

        FilteredAjaxForm.toggleFormSelects(this.ajaxForm.formElements, true);
        FilteredAjaxForm.toggleVisible(this.ajaxForm.content);
        FilteredAjaxForm.toggleVisible(this.settings.loader);

        $.ajax({
            type: form.attr("method"),
            url: form.data("action"),
            cache: false,
            data: payload,
            success: function (response) {
                that.submitFormSuccess(response);
            },
            error: function (response) {
                that.submitFormFailure(response);
            }
        });
    }
}

FilteredAjaxForm.prototype.submitFormSuccess = function (response) {
    try {
        this.unbindForm();

        const refreshedMarkup = document.createElement("div");
        refreshedMarkup.innerHTML = htmlsanitizer.SanitizeHtml(response);

        const refreshedContent = refreshedMarkup.querySelector(this.settings.contentSelector);
        const refreshedForm = refreshedMarkup.querySelector(this.settings.formSelector);

        if (refreshedForm != null && refreshedForm.getAttribute("data-findfailure").toLowerCase() !== "true") {
            Array.from(refreshedForm).forEach(function (element) {
                if (element.nodeName.toLowerCase() === "select") {
                    const existingSelect = this.ajaxForm.formElements.find(function (item) {
                        return item.name === element.name;
                    });

                    if (existingSelect !== undefined && existingSelect != null) {
                        existingSelect.replaceWith(element);
                    }
                }
            }, this);
        }

        if (refreshedForm !== undefined && refreshedForm != null) {
            this.ajaxForm.form.setAttribute("data-findfailure", refreshedForm.getAttribute("data-findfailure"));
        }
        this.ajaxForm.content.replaceWith(refreshedContent);

        BDC.Mobile.learnMoreBehavior();
    }
    catch (e) {
        console.log(e);
    }
    finally {
        this.bindForm();

        FilteredAjaxForm.toggleVisible(this.settings.loader);
        this.ajaxForm.content.classList.remove("hide");
    }
}

FilteredAjaxForm.prototype.submitFormFailure = function (response) {
    console.log("Error submitting form.");
    console.log(response);

    FilteredAjaxForm.toggleFormSelects(this.ajaxForm.formElements, false);
    FilteredAjaxForm.toggleVisible(this.ajaxForm.content);
    FilteredAjaxForm.toggleVisible(this.settings.loader);
}

FilteredAjaxForm.toggleFormSelects = function (formElements, disabled) {
    formElements.forEach(function (element) {
        if (element.nodeName.toLowerCase() === "select") {
            element.disabled = disabled;
        }
    });
}

FilteredAjaxForm.toggleVisible = function (element) {
    if (element != null) {
        element.classList.toggle("hide");
    }
}

FilteredAjaxForm.checkSelector = function (targetElement, selector) {
    const element = targetElement.querySelector(selector);
    if (element == null) {
        throw `Cannot initialize AjaxForm for ${targetElement}, cannot find element for selector '${selector}'.`;
    }

    return element;
}

FilteredAjaxForm.prototype.viewMoreCompanies = function (event) {
    const that = this;
    event.stopPropagation();
    const target = event.currentTarget;
    const idParentContainer = $(target).data("container-id");
    const form = $(target.form);
    const itemList = $(`#${idParentContainer}`).find(".companies-list");

    target.form.elements["pageNumber"].value++;
    const payload = form.serialize();
    $(`#${idParentContainer}`).find(".view-more-company-container").remove();
    FilteredAjaxForm.toggleVisible(this.settings.loader);
    
    $.ajax({
        type: "GET",
        url: itemList.data("url"),
        data: payload,
        cache: false,
        success: function (data) {
            FilteredAjaxForm.toggleVisible(that.settings.loader);

            itemList.append(htmlsanitizer.SanitizeHtml(data));

            $(`#${idParentContainer}`).find("button").on("click", that.settings.boundSubmitHandler);
        },
        error: function (data) {
            console.warn("error data", data);
        }
    });
}